import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ErrorLogModal({ show, handleClose, log }) {
  const { t } = useTranslation('common');

  return (
    <Modal className="common-custom-modal modal-md" show={show}>
      <Modal.Header>
        <Modal.Title>{t('POMS.GRADING_GROUP.ERROR_LOG_MODAL.EXCEL_IMPORT_ERROR')}</Modal.Title>
        <span onClick={() => handleClose()} className="icon-close" />
      </Modal.Header>
      <Modal.Body>
        <p>{t('POMS.GRADING_GROUP.ERROR_LOG_MODAL.PARTIALLY_FULLY_SUCCESSFUL')}</p>
        <p>{t('POMS.GRADING_GROUP.ERROR_LOG_MODAL.RESON_RESULT')}</p>
        <ul>
          {log.map((eleItem) => {
            return (
              <li key={eleItem}>
                <p>
                  {eleItem?.code} {eleItem?.message}
                </p>
              </li>
            );
          })}
        </ul>
      </Modal.Body>
    </Modal>
  );
}

export default ErrorLogModal;
